import React from "react"

export const YahooIcon = () => {
    return (
        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.71484 3.00781H8.28516L4.42969 12.25H1.85938L2.89844 9.81641L0 3.00781H2.65234L4.18359 6.91797L5.71484 3.00781ZM8.61328 6.69922C9.48828 6.69922 10.1992 7.41016 10.1992 8.3125C10.1992 8.58594 10.1172 8.85938 9.98047 9.10547C9.37891 10.1445 7.84766 10.1445 7.21875 9.10547C6.61719 8.03906 7.38281 6.69922 8.61328 6.69922ZM10.3906 0H13.2617L10.7188 6.125H7.84766L10.3906 0Z"
                fill="#495057"
            />
        </svg>
    )
}
